module.exports = __webpack_public_path__ + "static/media/phone-call-white.573abeee.svg";